export default __webpack_public_path__ + "static/media/White-comment.a9d11685.svg";